<template>
	<div id="dashboard-navigation">
		<div class="dash__section-title">Navigation</div>
		<router-link 
	            active-class="db-nav-active" 
	            :to="{ path : '/dashboard'}" 
	            exact
	            class="btn dash-nav__switch dash-nav__switch--quotes"
	        >
			
	        <span>Quotations ({{numberOfQuotations ? numberOfQuotations.length : '0'}})</span>
	    </router-link>
	    <router-link 
	            active-class="db-nav-active" 
	            :to="{ path : '/dashboard/surveys'}" 
	            exact
	            class="btn dash-nav__switch dash-nav__switch--surveys"
	        >
	        <span>Surveys ({{numberOfSurveys ? numberOfSurveys.length : '0'}})</span>
	    </router-link>
	</div>
</template>

<script>
	export default {
		computed : {
			numberOfQuotations(){
				return this.$store.getters.getQuotations
			},
			numberOfSurveys(){
				return this.$store.getters.getOnGoingSurveys
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Dashboard/DBNav.vue